/** @jsxImportSource @emotion/react */
import { FC } from "react";

export const DirectDebitIcon: FC<{}> = () => (
  <svg
    css={{
      display: "block",
    }}
    width="24"
    height="24"
    viewBox="0 0 32 32"
    focusable="false"
    role="img"
  >
    <path
      d="M7 10v12h18V10H7zM6 8h20a1 1 0 011 1v14a1 1 0 01-1 1H6a1 1 0 01-1-1V9a1 1 0 011-1z"
      fill="#fff"
    />
    <path
      d="M6.5 13.5h19"
      strokeWidth="2"
      strokeLinecap="square"
      stroke="#fff"
    />
    <path
      d="M9.5 19.5h3"
      strokeWidth="1"
      strokeLinecap="square"
      stroke="#fff"
    />
  </svg>
);
